import SuperRepository from '../superRepository'

export default new (class AdvertisersCostRepository extends SuperRepository {
  baseUri() {
    return 'advertiser_cost'
  }
  bulkCreate = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/bulk_create`, data, { signal })
  bulkUpdate = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/bulk_update`, data, { signal })
  bulkDelete = ids => this.httpClient().delete(`${this.baseUri()}/bulk_delete?${ids}`)
  saveToSheet = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/save_to_sheet`, data, { signal })
})()